var _rect, _path, _ellipse, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 64,
    viewBox: "0 0 93 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 61,
    rx: 5,
    fill: "#2D2D6C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3828 30.2654L35.3087 43.4723L35.3087 17.0585L61.3828 30.2654Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5,
    cy: 53.1379,
    rx: 10.5,
    ry: 10.1379,
    fill: "#2D2D6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0688,
    y: 52.2737,
    width: 10.8621,
    height: 1.48119,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7593,
    y: 58.5688,
    width: 10.8621,
    height: 1.48119,
    transform: "rotate(-90 81.7593 58.5688)",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/video_upload.038020dc4547407ef5b6755041dc5c92.svg";